import {
  QUESTION_TYPE_MULTIPLE_CHOICE,
  getEffectiveQuestionType,
  validateMcqQuestion,
} from "./mcqQuestion";

export const optionDisplayLabel = (index) => String.fromCharCode(65 + index);

export const isMultipleChoiceQuestion = (question) =>
  getEffectiveQuestionType(question?.questionType) === QUESTION_TYPE_MULTIPLE_CHOICE;

export const calculateQuizTotalMarks = (questions = []) =>
  questions.reduce(
    (total, question) => total + (parseFloat(question?.maxMark) || 0),
    0
  );

export const formatQuizMarkCount = (marks) =>
  `${marks} ${Number(marks) === 1 ? "mark" : "marks"}`;

const questionDisplayName = (question, index) => {
  if (typeof question?.questionLabel === "string" && question.questionLabel.trim()) {
    return `Question ${question.questionLabel.trim()}`;
  }
  if (typeof question?.questionText === "string" && question.questionText.trim()) {
    const text = question.questionText.trim();
    return `Question ${index + 1} (${text.slice(0, 48)}${text.length > 48 ? "…" : ""})`;
  }
  return `Question ${index + 1}`;
};

export const validateQuizQuestionSelection = (questions = []) => {
  const invalidQuestions = [];

  questions.forEach((question, index) => {
    if (!isMultipleChoiceQuestion(question)) return;

    const validation = validateMcqQuestion(question);
    const errors = [...validation.errors];
    if (Number(question.maxMark) !== 1) {
      errors.push("Multiple-choice questions must have a maximum mark of 1.");
    }

    if (errors.length > 0) {
      invalidQuestions.push({
        id: question.id || "",
        label: questionDisplayName(question, index),
        errors,
      });
    }
  });

  return {
    isValid: invalidQuestions.length === 0,
    invalidQuestions,
  };
};

export const quizQuestionValidationMessage = (validation) => {
  const first = validation?.invalidQuestions?.[0];
  if (!first) return "";
  return `${first.label} needs fixing before this test can be saved: ${first.errors.join(" ")}`;
};

export const mcqOptionsForDisplay = (question) =>
  isMultipleChoiceQuestion(question) && Array.isArray(question.options)
    ? question.options.map((option, index) => ({
        id: option?.id || "",
        label: optionDisplayLabel(index),
        text: String(option?.text || ""),
      }))
    : [];

export const resolvedCorrectOptionForTeacher = (question) => {
  if (!isMultipleChoiceQuestion(question)) return null;
  return mcqOptionsForDisplay(question).find(
    (option) => option.id === question.correctOptionId
  ) || null;
};
